module.exports = __webpack_public_path__ + "media/video3.e0b3c901.mp4";